<template>
  <div>Renewing token...</div>
</template>

<script>
import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc'
export default {
  created() {
    vuexOidcProcessSilentSignInCallback();
  }
}
</script>
